<template>
  <van-form ref="form" v-model="form">
    <van-field
      v-model="form.name"
      name="name"
      label="姓名"
      maxlength="5"
      :rules="[{ required: true, message: '请填写姓名' }]"
    />
    <van-field
      v-model="form.age"
      label="年龄"
      type="number"
      maxlength="2"
      name="age"
      :rules="formRules.age"
    />
    <van-field
      v-model="form.relation"
      label="关系"
      name="relation"
      maxlength="6"
      :rules="[{ required: true, message: '请填写与其关系' }]"
    />
    <van-field
      v-model="form.unit"
      label="现工作单位或就读学校"
      maxlength="10"
      name="unit"
      :rules="[{ required: true, message: '请填写现工作单位或就读学校' }]"
    />
    <van-field
      v-model="form.tel"
      label="联系电话"
      type="number"
      maxlength="11"
      maxleng
      name="tel"
      :rules="formRules.phone"
    />
  </van-form>
</template>
<script>
import formRules from '@/comm/rules.js'
export default {
  name: 'EditFamilyContact',
  props: {
    'familyContactData': {
      type: Object,
      default: null,
      require: false
    }
  },
  setup() {
    return {
      formRules
    }
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        age: '',
        relation: '',
        unit: '',
        tel: ''
      }
    }
  },
  watch: {
    familyContactData: {
      handler(val) {
        this.form = val
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onReset() {
      this.$refs.form.resetValidation()
    },
    validateForm() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped>

</style>
